/**
 * Sentry browser SDK configuration, injected into the client bundle by the
 * `@sentry/gatsby` plugin. Since v8 the plugin no longer reads SDK options from
 * gatsby-config, so they must be set here.
 */
import * as Sentry from "@sentry/gatsby";

const environment = process.env.GATSBY_ENV || process.env.NODE_ENV;

Sentry.init({
  dsn: "https://d7f75922a54e48378ee1df6c17d0e4f5@o1018445.ingest.sentry.io/5984180",
  sampleRate: 0.7,
  environment,
  // Reporting is off for this project, as it has been since May 2024. To turn
  // it on, use `enabled: environment !== "development"`.
  enabled: false,
  // Leaving this unset collects user info, cookies and request bodies by
  // default since v11. These values keep the previous (v10) defaults.
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: {
      request: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
      response: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
    },
    httpBodies: [],
    urlQueryParams: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
    genAI: { inputs: false, outputs: false },
    databaseQueryData: false,
    queues: false,
    graphQL: { document: false, variables: false },
  },
});
